"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_INFINITE_SCROLL_SIZE = exports.ACCEPT_LANGUAGE_MAP = void 0;
exports.genShortUID = genShortUID;
exports.getCidrMap = exports.getCidrInfo = exports.getCidrCnfig = void 0;
exports.getCookie = getCookie;
exports.getCurLocale = getCurLocale;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var ACCEPT_LANGUAGE_MAP = {
  cn: 'zh-CN,zh;q=0.9,en;q=0.8',
  en: 'en,*'
};
exports.ACCEPT_LANGUAGE_MAP = ACCEPT_LANGUAGE_MAP;
var DEFAULT_INFINITE_SCROLL_SIZE = 50;
exports.DEFAULT_INFINITE_SCROLL_SIZE = DEFAULT_INFINITE_SCROLL_SIZE;
function getCookie(key) {
  var name = key + '=';
  // $isServer
  if (typeof document !== 'undefined') {
    var decodedCookie = decodeURIComponent(document && document.cookie);
    var cookieList = decodedCookie.split(';');
    for (var i = 0; i < cookieList.length; i++) {
      var cookieItem = cookieList[i];
      while (cookieItem.charAt(0) === ' ') {
        cookieItem = cookieItem.substring(1);
      }
      if (cookieItem.indexOf(name) === 0) {
        return cookieItem.substring(name.length, cookieItem.length);
      }
    }
  }
  return null;
}
function genShortUID() {
  var _context, _context2;
  var firstPart = Math.random() * 46656 | 0;
  var secondPart = Math.random() * 46656 | 0;
  firstPart = (0, _slice.default)(_context = '000' + firstPart.toString(36)).call(_context, -3);
  secondPart = (0, _slice.default)(_context2 = '000' + secondPart.toString(36)).call(_context2, -3);
  return firstPart + secondPart;
}
function getCurLocale() {
  var LOCALE_COOKIE_NAME = 'jdcloud_sitelang';
  return getCookie(LOCALE_COOKIE_NAME) || 'cn';
}

// vpc/subnet cidr
var getCidrCnfig = function getCidrCnfig(step) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 255;
  var rangeList = [];
  var tip = '';
  if (step && !isNaN(Number(step)) && step < 256) {
    for (var i = min; i <= max; i += step) {
      rangeList.push(i);
    }
    if (rangeList.length) {
      if (rangeList.length === 256) {
        tip = '0~255';
      } else if (rangeList.length > 4) {
        if (step === 1) {
          var _context3;
          tip = (0, _concat.default)(_context3 = "".concat(rangeList[0], "~")).call(_context3, rangeList[rangeList.length - 1]);
        } else {
          var _context4, _context5;
          tip = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(rangeList[0], ",")).call(_context5, rangeList[1], "...,")).call(_context4, rangeList[rangeList.length - 1]);
        }
      } else if (rangeList.length) {
        tip = "".concat(rangeList.join(','));
      }
    }
  }
  return {
    rangeList: rangeList,
    tip: tip
  };
};
exports.getCidrCnfig = getCidrCnfig;
var getCidrInfo = function getCidrInfo() {
  var masks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var vpcCidr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var maskArr = masks;
  var vpcIps = [];
  var vpcMask = 0;
  if (vpcCidr) {
    var _vpcCidr$split = vpcCidr.split('/'),
      _vpcCidr$split2 = (0, _slicedToArray2.default)(_vpcCidr$split, 2),
      _vpcCidr$split2$ = _vpcCidr$split2[0],
      ipStr = _vpcCidr$split2$ === void 0 ? '' : _vpcCidr$split2$,
      _vpcCidr$split2$2 = _vpcCidr$split2[1],
      mask = _vpcCidr$split2$2 === void 0 ? '' : _vpcCidr$split2$2;
    if (ipStr && mask) {
      var _context6;
      vpcIps = (0, _map.default)(_context6 = ipStr.split('.')).call(_context6, function (val) {
        return Number(val);
      });
      vpcMask = Number(mask);
      maskArr = (0, _filter.default)(masks).call(masks, function (val) {
        return val >= Number(mask);
      });
    }
  }
  return {
    maskArr: maskArr,
    vpcIps: vpcIps,
    vpcMask: vpcMask
  };
};
// A.B.C.D:N 获取 N -->A、B、C、D 的映射配置
exports.getCidrInfo = getCidrInfo;
var getCidrMap = function getCidrMap() {
  var masks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var vpcCidr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _getCidrInfo = getCidrInfo(masks, vpcCidr),
    maskArr = _getCidrInfo.maskArr,
    vpcIps = _getCidrInfo.vpcIps,
    vpcMask = _getCidrInfo.vpcMask;
  var map = {};
  maskArr.forEach(function (mask) {
    var cidrA = {
      min: 0,
      max: 255,
      step: 1
    };
    var cidrB = {
      min: 0,
      max: 255,
      step: 1
    };
    var cidrC = {
      min: 0,
      max: 255,
      step: 1
    };
    var cidrD = {
      min: 0,
      max: 255,
      step: 1
    };
    var visible = true;
    if (vpcMask && vpcIps.length) {
      if (vpcMask <= mask) {
        if (vpcMask > 16 && vpcMask < 24) {
          cidrC.min = parseInt(vpcIps[2], 10);
          cidrC.step = Math.ceil(Math.pow(2, 24 - mask));
          cidrC.max = vpcIps[2] + Math.ceil(Math.pow(2, 24 - vpcMask)) - cidrC.step;
        } else {
          if (mask > 16 && mask < 24) {
            cidrC.step = Math.ceil(Math.pow(2, 24 - mask));
            cidrC.max = 256 - cidrC.step;
          }
        }
        if (vpcMask >= 24 || mask === 16) {
          cidrC.step = null;
        }
        if (vpcMask >= 24) {
          cidrD.min = parseInt(vpcIps[3], 10);
          cidrD.step = Math.ceil(Math.pow(2, 32 - mask));
          cidrD.max = vpcIps[3] + Math.ceil(Math.pow(2, 32 - vpcMask)) - cidrD.step;
        } else {
          if (mask >= 24) {
            cidrD.step = Math.ceil(Math.pow(2, 32 - mask)); // 剩余x位 就有2^x种可能需要遗留，因此增量是2^x
            cidrD.max = 256 - cidrD.step;
          }
        }
        if (mask <= 24) {
          cidrD.step = null;
        }
      } else {
        visible = false;
      }
    } else {
      if (mask === 0) {
        cidrA.step = null;
        cidrB.step = null;
        cidrC.step = null;
        cidrD.step = null;
      } else if (mask > 0 && mask <= 8) {
        cidrA.step = Math.pow(2, 8 - mask);
        cidrA.max = 256 - cidrD.step;
        cidrB.step = null;
        cidrC.step = null;
        cidrD.step = null;
      } else if (mask > 8 && mask <= 16) {
        cidrB.step = Math.pow(2, 16 - mask);
        cidrB.max = 256 - cidrD.step;
        cidrC.step = null;
        cidrD.step = null;
      } else if (mask > 16 && mask < 24) {
        cidrC.step = Math.pow(2, 24 - mask);
        cidrC.max = 256 - cidrC.step;
        cidrD.step = null;
      } else if (mask >= 24) {
        cidrD.step = Math.pow(2, 32 - mask);
        cidrD.max = 256 - cidrD.step;
      }
    }
    if (visible) {
      var cidrAConfig = getCidrCnfig(cidrA.step, cidrA.min, cidrA.max);
      var cidrBConfig = getCidrCnfig(cidrB.step, cidrB.min, cidrB.max);
      var cidrCConfig = getCidrCnfig(cidrC.step, cidrC.min, cidrC.max);
      var cidrDConfig = getCidrCnfig(cidrD.step, cidrD.min, cidrD.max);
      map[mask] = {
        cidrATip: cidrAConfig.tip,
        cidrBTip: cidrBConfig.tip,
        cidrCTip: cidrCConfig.tip,
        cidrDTip: cidrDConfig.tip,
        cidrARange: cidrAConfig.rangeList,
        cidrBRange: cidrBConfig.rangeList,
        cidrCRange: cidrCConfig.rangeList,
        cidrDRange: cidrDConfig.rangeList
      };
    }
  });
  return map;
};
exports.getCidrMap = getCidrMap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/utils/util.js
// module id = JFF+
// module chunks = 19